export default __webpack_public_path__ + "static/media/database.efb03dc3.svg";